import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Button, Spin } from "antd";
import { RETARD_MILISEGONS_APARICIO_SPINNER } from "../../constantsObservacions";
import styles from "./ObservadorIntroduccio.module.css";
import ObservadorFormulari from "./ObservadorFormulari";
import ErrorBoundaryWrapper from "../commons/ErrorBoundaryWrapper";

import {
  getIdObservadorLlista,
  getPeticioEnviarFormulariEnCurs
} from "../../reducers";
import {
  observadorIntroduccioDescartarCanvis,
  observadorIntroduccioEnviarFormulari
} from "../../actions";

import { rutaObservadors, rutaDetallObservador } from "../../routes";

class ObservadorIntroduccio extends Component {
  generarBotoCancelar() {
    const {
      idObservador,
      peticioEnviarFormulariEnCurs,
      observadorIntroduccioDescartarCanvis
    } = this.props;

    const ruta = idObservador === null ? rutaObservadors : rutaDetallObservador;
    const onClick = observadorIntroduccioDescartarCanvis;

    return (
      <Link to={ruta}>
        <Button
          size="large"
          disabled={peticioEnviarFormulariEnCurs}
          onClick={onClick}
        >
          Cancel·lar
        </Button>
      </Link>
    );
  }

  render() {
    const {
      history,
      peticioEnviarFormulariEnCurs,
      observadorIntroduccioEnviarFormulari
    } = this.props;

    const botoCancelar = this.generarBotoCancelar();

    return (
      <Spin
        spinning={peticioEnviarFormulariEnCurs}
        delay={RETARD_MILISEGONS_APARICIO_SPINNER}
      >
        <div className={styles.observadorIntroduccioDetall}>
          <div className={styles.observadorIntroduccioDetallContenidor}>
            <ObservadorFormulari esEditable={true} />
          </div>
          <div className={styles.observadorIntroduccioDetallBotons}>
            <Button
              type="primary"
              size="large"
              disabled={peticioEnviarFormulariEnCurs}
              onClick={() => observadorIntroduccioEnviarFormulari(history)}
            >
              Guardar
            </Button>
            {botoCancelar}
          </div>
        </div>
      </Spin>
    );
  }
}

ObservadorIntroduccio.propTypes = {
  idObservador: PropTypes.number,
  peticioEnviarFormulariEnCurs: PropTypes.bool,
  observadorIntroduccioDescartarCanvis: PropTypes.func,
  observadorIntroduccioEnviarFormulari: PropTypes.func,
  history: PropTypes.object
};

const mapStateToProps = state => {
  return {
    idObservador: getIdObservadorLlista(state),
    peticioEnviarFormulariEnCurs: getPeticioEnviarFormulariEnCurs(state)
  };
};

const mapDispatchToProps = {
  observadorIntroduccioDescartarCanvis,
  observadorIntroduccioEnviarFormulari
};

export default ErrorBoundaryWrapper(
  connect(mapStateToProps, mapDispatchToProps)(ObservadorIntroduccio)
);
